import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit, AfterViewInit {
  
  public lottieConfig = {
    path: '../../../assets/lottie/404-error-page.json',
    autoplay: true,
    loop: true
  };

  
  constructor(public router: Router) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    
  }

}
